import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { getMyReportExports } from '../../../services/reportExportService';

export const POLL_INTERVAL_MS = 4000;

export const isActiveExport = (job) => job?.status === 'queued' || job?.status === 'running';

// AKM POC §7.1 — "Dışa Aktarmalarım": çağıranın son 50 dışa aktarması. Sıradaki / hazırlanan iş varken 4 sn'de bir
// yoklanır (zincirli setTimeout — yanıtlar üst üste binmez); yoklama başarısız olursa durur. api.js GET'te reddetmez:
// "yüklenemedi" = res.data.status === false (boş liste DEĞİL).
export function useMyExports() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const mounted = useRef(true);

  useEffect(() => () => { mounted.current = false; }, []);

  const load = useCallback(async ({ silent = false } = {}) => {
    if (!silent) setLoading(true);
    const res = await getMyReportExports();
    if (!mounted.current) return false;
    if (!silent) setLoading(false);
    if (!res?.data || res.data.status === false) {
      setFailed(true);
      return false;
    }
    setJobs(Array.isArray(res.data.data) ? res.data.data : []);
    setFailed(false);
    return true;
  }, []);

  useEffect(() => { load(); }, [load]);

  const hasActive = useMemo(() => jobs.some(isActiveExport), [jobs]);

  useEffect(() => {
    if (!hasActive || failed) return undefined;
    let stopped = false;
    let timer;
    const tick = async () => {
      const ok = await load({ silent: true });
      if (!stopped && ok) timer = setTimeout(tick, POLL_INTERVAL_MS);
    };
    timer = setTimeout(tick, POLL_INTERVAL_MS);
    return () => {
      stopped = true;
      clearTimeout(timer);
    };
  }, [hasActive, failed, load]);

  return { jobs, loading, failed, reload: load };
}

/** Bayt → "12,3 KB" (yerel ondalık). */
export function formatBytes(bytes, locale) {
  if (bytes === null || bytes === undefined) return '-';
  const units = ['B', 'KB', 'MB', 'GB'];
  let value = Number(bytes);
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toLocaleString(locale, { maximumFractionDigits: unit === 0 ? 0 : 1 })} ${units[unit]}`;
}
